export {blockquoteNodeName, blockquoteType, isBlockqouteNode} from './BlockquoteSpecs';
